module.exports = __webpack_public_path__ + "static/media/23.5af5e870.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/23.jpg
// module id = 584
// module chunks = 0